import { formatStringToFloatDecimalCase } from "src/utils/format-decimal"
import { formatDate } from "src/utils/format-date"

const formatBondsDate = (value) => (value ? formatDate(value) : "")
const formatBondsNumber = (value) =>
    value != null ? formatStringToFloatDecimalCase(value) : ""
const getBondsNumberSortValue = (value) => {
    const numericValue = Number(value)

    return Number.isFinite(numericValue) ? numericValue : value
}

export const createBondsPriceRows = (bonds) =>
    bonds.map((bond, index) => ({
        ...bond,
        id: bond.ISIN || `bond-${index}`,
    }))

export const BONDS_PRICE_COLUMNS = [
    {
        field: "Data Referência",
        headerName: "Data Referência",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsDate(row["Data Referência"]),
    },
    { field: "ISIN", headerName: "ISIN", flex: 1, minWidth: 150 },
    {
        field: "Emissão",
        headerName: "Emissão",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsDate(row["Emissão"]),
    },
    {
        field: "Vencimento",
        headerName: "Vencimento",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsDate(row["Vencimento"]),
    },
    {
        field: "Devedor",
        headerName: "Devedor",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => row["Devedor"] || "",
    },
    {
        field: "Moeda",
        headerName: "Moeda",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => row["Moeda"] || "",
    },
    {
        field: "Valor Nominal",
        headerName: "Valor Nominal",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsNumber(row["Valor Nominal"]),
        sortValueGetter: ({ value }) => getBondsNumberSortValue(value),
    },
    {
        field: "Taxa MTM",
        headerName: "Taxa MTM",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsNumber(row["Taxa MTM"]),
        sortValueGetter: ({ value }) => getBondsNumberSortValue(value),
    },
    {
        field: "PU MTM Limpo",
        headerName: "PU MTM Limpo",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsNumber(row["PU MTM Limpo"]),
        sortValueGetter: ({ value }) => getBondsNumberSortValue(value),
    },
    {
        field: "PU MTM Sujo",
        headerName: "PU MTM Sujo",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsNumber(row["PU MTM Sujo"]),
        sortValueGetter: ({ value }) => getBondsNumberSortValue(value),
    },
    {
        field: "PercPUPAR Limpo",
        headerName: "%PUPAR Limpo",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsNumber(row["PercPUPAR Limpo"]),
        sortValueGetter: ({ value }) => getBondsNumberSortValue(value),
    },
    {
        field: "PercPUPAR Sujo",
        headerName: "%PUPAR Sujo",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsNumber(row["PercPUPAR Sujo"]),
        sortValueGetter: ({ value }) => getBondsNumberSortValue(value),
    },
    {
        field: "Duration DC",
        headerName: "Duration DC",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsNumber(row["Duration DC"]),
        sortValueGetter: ({ value }) => getBondsNumberSortValue(value),
    },
    {
        field: "Duration Ano",
        headerName: "Duration Ano",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsNumber(row["Duration Ano"]),
        sortValueGetter: ({ value }) => getBondsNumberSortValue(value),
    },
    {
        field: "Data Próximo Cupom",
        headerName: "Data Próximo Cupom",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsDate(row["Data Próximo Cupom"]),
    },
    {
        field: "Cupom Accruado",
        headerName: "Cupom Accruado",
        flex: 1,
        minWidth: 150,
        valueGetter: ({ row }) => formatBondsNumber(row["Cupom Accruado"]),
        sortValueGetter: ({ value }) => getBondsNumberSortValue(value),
    },
]
